
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/te-doen",
      function () {
        return require("private-next-pages/te-doen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/te-doen"])
      });
    }
  